import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { DeleteDraftJobDialog } from '@/features/jobs/drafting/components/DeleteDraftJobDialog'
import type { DeleteDraftJobDialogViewModel } from './DeleteDraftJobDialogViewModel'

export interface DeleteDraftJobDialogContainerProps {
  vm: DeleteDraftJobDialogViewModel
}

export const DeleteDraftJobDialogContainer = observer(
  function DeleteDraftJobDialogContainer({
    vm,
  }: DeleteDraftJobDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <DeleteDraftJobDialog
        showing={vm.modal.showing}
        corporateMode={shellInfo.corporateMode}
        isDeletePending={vm.delete.pending}
        isDeleteRejected={vm.delete.rejected}
        deleteError={vm.delete.error}
        onClose={vm.modal.close}
        onDelete={vm.delete}
        onDismissError={vm.delete.reset}
      />
    )
  },
)
